module.exports = __webpack_public_path__ + "static/media/silkycloud-red-1.f5d567e0.png";